import Vue from 'vue'

export const SET_RATING = 'SET_RATING';

export default {
  state: {rating: 0},
  mutations: {
    [SET_RATING](state, rating) {
      Vue.set(state, 'rating', rating)
    },

  },
  actions: {
    [SET_RATING]({commit}, rating) {
      commit(SET_RATING, rating)
    },

  }
}



// WEBPACK FOOTER //
// ./src/store/imageRating.js